import { requestCDN } from "../../apis";

export const apiGetAreaCode = (): any => {
  const millis = Date.now();
  return requestCDN("get", `/phoneCode.json?v=${millis}`);
};
